import { render } from "./ThankYouModalContainer.vue?vue&type=template&id=7dc85932&scoped=true&ts=true&lang=pug"
import script from "./ThankYouModalContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThankYouModalContainer.vue?vue&type=script&setup=true&lang=ts"

import "./ThankYouModalContainer.vue?vue&type=style&index=0&id=7dc85932&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc85932"]])

export default __exports__